"use client"

import { createContext } from "react"

import PageThemeData from "./PageThemeData"

// This creates the context for the PageTheme
// Pages are by default dark.
// If you want to change the context based on the page please see components/page-theme/PageThemeData.tsx

export interface IPageTheme {
  location: string
  dark: boolean
  bgColorClass: string
  bgColorClassFooter: string
  bgColorHex: string
  bgColorHexFooter: string
}

interface IPageThemeContext {
  pageTheme: IPageTheme
}

const defaultState = {
  pageTheme: {
    location: "/",
    dark: true,
    bgColorClass: "bg-gray-90",
    bgColorClassFooter: "bg-gray-90",
    bgColorHex: "#141a1f",
    bgColorHexFooter: "#141a1f",
  },
}

function stripTrailingSlash(str) {
  return str.replace(/\/$/, "")
}

export const getPageTheme = (pLocationPathName: string): IPageTheme => {
  // On Vercel server does not include trailing slash, so strip it to make client pathname match server pathname
  const pathnameWithoutTrailingSlash = stripTrailingSlash(pLocationPathName)
  const dynamicJobsRoute = "/careers/all-jobs"
  const pageTheme = PageThemeData.find(
    (page) =>
      page.location === pathnameWithoutTrailingSlash ||
      (pathnameWithoutTrailingSlash.startsWith(dynamicJobsRoute) &&
        page.location === dynamicJobsRoute),
  )
  if (pageTheme) {
    return pageTheme
  }
  return defaultState.pageTheme
}

const PageThemeContext = createContext<IPageThemeContext>(defaultState)

export default PageThemeContext
